import React, { useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';
import axios from 'axios';
import '../Styles/Login.css';
import Navbar from '../Components/Core/Navbar';
import api from "../api";
import { useNavigate } from 'react-router-dom';
import img3 from "../Images/5784989.jpg"
import img4 from "../Images/iphone16_PNG13.png"
import { showToast } from '../Components/PopupMessage';
import { toast } from 'react-toastify';

const Login = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(Array(4).fill(''));
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSendOtp = async () => {


if(email === '') {
  toast.warning("Please enter your email address");
  return
}

if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
  toast.warning("Please enter a valid email address");
  return
}
  

    try {
      setLoading(true);
      setError('');
      const response = await api.post("/user_api/signup/send-otp", { email });
      console.log(response.data);
      setTimer(60);
      setIsActive(true);
      setStep(2);
    } catch (err) {
      setError('Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {

    try {
      setLoading(true);
      setError('');
      console.log('Email:', email);

      const otpString = otp.join('');
      const otpNumber = Number(otpString);

      console.log('otpNumber:', otpNumber);

      if (!otpNumber || otpString.length !== 4) {
        setError('Invalid OTP. Please enter a valid OTP.');
        return;
      }

      const response = await api.post("/user_api/signup/verify-otp", {
        email,
        otp: otpNumber,
      });

      if (response.data.status === "success") {
        console.log("Logged in successful:", response.data);
        localStorage.setItem("accessToken", JSON.stringify(response.data.user_details.remember_token));
        showToast("Signin successfulliy", "success");
        navigate("/")

      } else {
        console.log(response.data.message);
        
        setError(response.data.message || 'Invalid OTP. Please try again.');
      }
    } catch (err) {
      setError('Invalid OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  window.onpopstate = () => {
    navigate("/");
  }



  const handleOtpChange = (value, index) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value !== '' && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    if (otp[index] === '') {
      if (index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        document.getElementById(`otp-${index - 1}`)?.focus();
        e.preventDefault(); // Prevent default backspace behavior
      }
    }
  }
};

  const [timer, setTimer] = useState(60);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    let interval = null;
    if (isActive && timer > 0) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setIsActive(false);
    }
    return () => clearInterval(interval);
  }, [isActive, timer]);

  const handleResend = () => {
    handleSendOtp();
    setOtp(Array(4).fill(''));
    console.log("Resend OTP");

    setTimer(60);
    setIsActive(true);
  };


  return (
    <div className="main-section1">
      <div className='Add_section' style={{ display: "flex", gap: "10px", marginBottom: "1px", justifyContent: "space-between", maxWidth: "388px" }}>
        <div style={{ width: "70%", fontSize: "16px", fontWeight: "600", display: "flex", color: "black", textShadow: "2px 2px 8px rgb(155, 175, 26)" }}>Dubai No-1 Shopping Platform for Any Branded Electronics with upto-30% off and Free Shiping</div>
        <div style={{ width: "30%", display: "flex", justifyContent: "center", height: "130px" }}><img src={img4} width="100%" height="100%" /></div>
      </div>
      <div className="login-container">
        <h2 className="login-title" style={{ alignSelf: "center" }}>Login or Signup</h2>

        {error && <p className="error-text">{error}</p>}

        {step === 1 && (
          <div className="input-group1">

            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="login-button" onClick={handleSendOtp} disabled={loading}>
              {loading ? 'Sending OTP...' : 'Send OTP'}
            </button>
          </div>
        )}

        {step === 2 && (
          <>
            <div className="input-group1">
              <h5 className="login-title" style={{ alignSelf: "self-start", fontSize: "14px", marginBottom: 10, }}>Enter OTP</h5>
              <div className="otp-inputs">
                {/* {otp?.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="number"
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                  />
                ))} */}
                {otp?.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                 type="text"
    inputMode="numeric"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                />
              ))}
              </div>
              <div className='resend-otp'>
                {isActive ? (
                  <p>Resend OTP in {timer} sec</p>
                ) : (
                  <button style={{ color: "#79a93b" }} onClick={handleResend}>Resend OTP</button>
                )}
              </div>
            </div>
            <button className="login-button" onClick={handleVerifyOtp} disabled={loading}>
              {loading ? 'Verifying...' : 'Verify OTP'}
            </button>
          </>
        )}
        
      </div>
    </div>
  );
};

export default Login;
